'use strict';
const angular = require('angular');
const mustache = require('mustache');

export class templateWidgetComponent {

  constructor(SettingsService, DynamicPageService) {
    'ngInject';

    this.SettingsService = SettingsService;
    this.DynamicPageService = DynamicPageService;
  }

  $onInit() {

    let _METHOD = (this.public === 'true') ? "getPublicByName" : "getByName";

    this.SettingsService[_METHOD]({name: this.settings}, setting => {
      let templateVars = (this.key) ? setting.data[this.key] : setting.data;

      if (Array.isArray(templateVars) && this.arraySearchKey && this.arraySearchValue) {
        templateVars = templateVars.find(o => o[this.arraySearchKey].toLowerCase().includes(this.arraySearchValue.toLowerCase()))
      }

      if (this.convertNewlineKeys && this.convertNewlineKeys.trim()) {
        const newlineKeys = this.convertNewlineKeys
          .trim()
          .split(',')
          .map(key => key.trim())
          .filter(key => key);    // removes empty keys

        newlineKeys.forEach(key => {
          templateVars[key] = this.newlineToBreak(templateVars[key]);
        })
      }

      if (this.convertToChunks && this.convertToChunks.trim()) {

        const chunkKeysAndNumber = this.convertToChunks
          .trim()
          .split(',')
          .map(key => key.trim())
          .filter(key => key)
          .map(keyAndNumber => {
            const obj = {};
            const splittedKeyAndNumber = keyAndNumber.split("#");

            obj.key = splittedKeyAndNumber[0].trim();
            obj.chunks = (splittedKeyAndNumber[1] && splittedKeyAndNumber[1].trim()) ? parseInt(splittedKeyAndNumber[1].trim(), 10) : 2;

            return obj;
          });

        chunkKeysAndNumber.forEach(keyAndChunks => {
          templateVars[keyAndChunks.key] = this.chunkIntoSets(templateVars[keyAndChunks.key], keyAndChunks.chunks);
        })
      }

      this.DynamicPageService[_METHOD]({name: this.template}, page => {
        let template = this.convertShortcode(page.data);
        this.html = mustache.render(template, templateVars);
      }, err => {
        console.log("could not retrieve template");
      });

    }, err => {
      console.log('could not retrieve data for template');
    });
  }

  convertShortcode(html) {
    return html.replace(/\[/g,"<").replace(/\]/g,">");
  }

  newlineToBreak(text) {
    return text.replace(/\n/g, '<br />')
  }

  chunkIntoSets(arr, numberOfSets) {
    const result = [];
    const chunkSize = Math.ceil(arr.length / numberOfSets);

    for (let i = 0; i < arr.length; i += chunkSize) {
      result.push(arr.slice(i, i + chunkSize));
    }

    return result;
  }


}

export default angular.module('conduuApp.templateWidget', [])
  .component('templateWidget', {
    template: require('./template-widget.component.html'),
    bindings: {
      template: '@',
      settings: '@',
      key: '@',
      public: '@',
      arraySearchKey: '@',
      arraySearchValue: '@',
      convertNewlineKeys: '@',
      convertToChunks:'@'
    },
    controller: templateWidgetComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/template-widget/template-widget.component.js